import React from 'react';

const Description = ({ state }) => {
  const merchantDescription =
    state.merchant.description ||
    state.merchant.extended_data.extended_string_data_7;

  return (
    <section
      className="sl-flex-1 sl-flex sl-flex-col"
      style={{ minWidth: 0 }}
      aria-labelledby="salon-description-title"
    >
      <h2 id="salon-description-title" className="sr-only">
        À propos du salon de coiffure {state.merchant.name}
      </h2>
      <p
        itemProp="description"
        style={{
          whiteSpace: 'pre-wrap',
          lineHeight: '22px',
          fontSize: '0.9rem',
        }}
      >
        {merchantDescription}
      </p>
    </section>
  );
};

export default Description;
